module.exports = __webpack_public_path__ + "static/media/First Light ZTG 4065_360.3f32854d.jpeg";